import {observer} from "mobx-react";
import React, {useState} from "react";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import Card from "../../../../../components/layouts/card/card";
import customerCaseStore from "../../stores/customer-case-store";
import DraftOrderGridLine from "./draft-order-grid-line";
import './rma-payments-exchanges-card.scss';
import PaymentGridLine from "./payment-grid-line";
import { CARD_SPACING_VARIANT } from "../../../../../components/layouts/card/card.types";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IRmaPaymentsExchangesProps {
    customerCaseStore: customerCaseStore;
    storeCurrencyCode: string;
}

const RmaPaymentsExchangesCard: React.FC<IRmaPaymentsExchangesProps> = observer(({customerCaseStore, storeCurrencyCode}) => {
const exchangeOrderList = customerCaseStore.exchangeOrderList;
const paymentList = customerCaseStore.paymentsStoreList;

const { getTranslation } = useDashboardTranslation();
const pageScope = 'dashboard-returns-rma-card';

const [isExpanded, setExpanded] = useState(false);
return (
    <div className={'rma-payments-exchanges-card'}>
        <Card
            toolbar={{
                title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{getTranslation('PAYMENTS_CARD_TITLE', pageScope)}</FontBody1>,
            }}
            isExpandable={true}
            isExpanded={isExpanded}
            expandCallback={setExpanded}
            spacingVariant={CARD_SPACING_VARIANT.SMAll}
        >
            {paymentList.filter(payment => !payment.isHidden).map((payment) => {
                return (<PaymentGridLine key={payment.paymentId} store={payment} />);
            })}
            {exchangeOrderList.map((exchangeOrderStore, index) => {
                return (<DraftOrderGridLine key={index} customerCaseStore={customerCaseStore} store={exchangeOrderStore} storeCurrencyCode={storeCurrencyCode}/>)
            })}
        </Card>
    </div>
)
});


export default RmaPaymentsExchangesCard;